import store from '@/store'

export const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters['user/isLoggedIn']) {
    next()
    return
  }
  next('/workspaces')
}

export const ifAuthenticated = (to, from, next) => {
  if (store.getters['user/isLoggedIn']) {
    next()
    return
  }
  next('/signin')
}

export default ifAuthenticated



// WEBPACK FOOTER //
// ./src/router/middleware.js